const C = {
  cream: "#F5F1EA",
  white: "#FFFFFF",
  dark: "#163C2F",
  green: "#7FB98E",
  greenPale: "#EAF2ED",
  muted: "#9B9690",
  border: "#D4CFC7",
};

export default function PaymentThankYou() {
  return (
    <div style={{ minHeight: "100vh", background: C.cream, fontFamily: "'Manrope', 'Outfit', sans-serif", padding: "0 16px" }}>
      <style>{`
        @keyframes checkPop {
          0%   { transform: scale(0); opacity: 0; }
          60%  { transform: scale(1.15); }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>

      <div style={{ maxWidth: 480, margin: "0 auto", paddingTop: 80, paddingBottom: 64, textAlign: "center" }}>
        {/* Checkmark */}
        <div style={{
          width: 80, height: 80, borderRadius: "50%",
          background: C.greenPale, border: `3px solid ${C.green}`,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          animation: "checkPop 0.5s ease-out",
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={C.dark} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 36, color: C.dark, marginTop: 28, marginBottom: 10, lineHeight: 1.1,
        }}>Payment Received!</h1>

        <p style={{ fontSize: 15, color: C.muted, lineHeight: 1.7, margin: "0 auto 36px", maxWidth: 360 }}>
          Thank you! Your payment has been processed successfully.
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
          <a href="/tenant?tab=payments" style={{
            display: "inline-flex", alignItems: "center", gap: 8, textDecoration: "none",
            background: C.white, color: C.dark, border: `1.5px solid ${C.dark}`,
            borderRadius: 999, padding: "13px 28px", fontWeight: 700, fontSize: 13,
            fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em",
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
            View Receipt
          </a>
          <a href="/tenant" style={{
            display: "inline-flex", alignItems: "center", gap: 8, textDecoration: "none",
            background: C.dark, color: C.cream, border: "none", borderRadius: 999,
            padding: "13px 28px", fontWeight: 700, fontSize: 13,
            fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em",
          }}>
            Back to Portal
          </a>
        </div>

        {/* Footer */}
        <p style={{ fontSize: 11, color: C.muted, marginTop: 48, opacity: 0.7 }}>
          Gibbs Prodigy Group &middot; Powered by Leasly
        </p>
      </div>
    </div>
  );
}
